// Product types of designs and installation tickets (panel, inverter, ...) in Dutch, and products
// grouped per type for the compact "AMOUNT x PRODUCT" lists in the call centre.
const PRODUCT_TYPE_LABELS: { [type: string]: string } = {
  panel: 'Zonnepanelen',
  inverter: 'Omvormer',
  optimizer: 'Optimizers',
  smartmeter: 'Norm Meter',
  mounting: 'Montagemateriaal',
  battery: 'Batterij',
  boiler: 'Boiler',
  heatpump: 'Warmtepomp',
  cable: 'Kabels',
}

export function productTypeLabel(type: string) {
  const label = PRODUCT_TYPE_LABELS[type] || type || 'Overig'
  return label.charAt(0).toUpperCase() + label.slice(1)
}

// products per type, in the order they come in; products without an amount left out
export function groupProductsByType<T extends { type: string; amount?: number }>(products: T[]) {
  const groups: { type: string; label: string; products: T[] }[] = []
  products.forEach((product) => {
    if (!product.amount) return
    let group = groups.find((g) => g.type === product.type)
    if (!group) {
      group = { type: product.type, label: productTypeLabel(product.type), products: [] }
      groups.push(group)
    }
    group.products.push(product)
  })
  return groups
}
